module.exports = __webpack_public_path__ + "img/1.3f906a08.jpg";